/**
 * Single source of truth for which URLs render the side nav. The Python
 * equivalent in `service_actions/side_nav_visibility.py` consumes the same
 * regex strings so server-rendered chrome matches the SPA on first paint.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get NO_SIDEBAR_PATTERN_STRINGS () {
        return NO_SIDEBAR_PATTERN_STRINGS;
    },
    get isAdminRoute () {
        return isAdminRoute;
    },
    get isNoSidebarRoute () {
        return isNoSidebarRoute;
    },
    get isSidebarVisibleRoute () {
        return isSidebarVisibleRoute;
    }
});
const _nosidebarpatternsjson = /*#__PURE__*/ _interop_require_default(require("./no-sidebar-patterns.json"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const NO_SIDEBAR_PATTERN_STRINGS = _nosidebarpatternsjson.default.patterns;
const NO_SIDEBAR_REGEXES = NO_SIDEBAR_PATTERN_STRINGS.map((p)=>new RegExp(p));
const isNoSidebarRoute = (pathname)=>NO_SIDEBAR_REGEXES.some((re)=>re.test(pathname));
const isSidebarVisibleRoute = (pathname)=>!isNoSidebarRoute(pathname);
const isAdminRoute = (pathname)=>pathname.startsWith("/administration") || pathname.startsWith("/super-user-admin");
